import React, { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { setLanguageEN } from '../../redux/appSlice';
import { floral } from '../language';

const NAV_ITEMS = [
  { id: 'home', key: 'home' },
  { id: 'about', key: 'about' },
  { id: 'weddings', key: 'weddings' },
  { id: 'portfolio', key: 'portfolio' },
  { id: 'collections', key: 'services' },
];

function scrollToSection(id) {
  if (id === 'home') {
    const contentBody = document.getElementById('content-body');
    if (contentBody) {
      contentBody.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }
    return;
  }
  const target = document.getElementById(id);
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' });
  }
}

function MainHeader(props) {
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);

  const languageEN = useSelector((state) => {
    return state.app.languageEN;
  });
  const language = languageEN ? 'en' : 'ch';

  function handleNavClick(id) {
    setMenuOpen(false);
    scrollToSection(id);
  }

  function handleLanguageToggle() {
    dispatch(setLanguageEN(!languageEN));
  }

  function handleMobileLanguageToggle() {
    setMenuOpen(false);
    dispatch(setLanguageEN(!languageEN));
  }

  return (
    <header id="lf-header" className="lf-header prevent-select">
      <div className="lf-editorial d-flex align-items-center justify-content-between">
        <a
          className="lf-wordmark lf-brand"
          onClick={() => {
            handleNavClick('home');
          }}
          translate="no"
        >
          Lynsis Event &amp; Floral
        </a>
        <nav className="lf-desktop-nav d-none d-lg-flex align-items-center" style={{ gap: '1.5rem' }}>
          {NAV_ITEMS.map((item) => {
            return (
              <a
                key={item.id}
                className="lf-nav-link"
                onClick={() => {
                  handleNavClick(item.id);
                }}
              >
                {floral.nav[item.key][language]}
              </a>
            );
          })}
        </nav>
        <div className="d-flex align-items-center" style={{ gap: '0.75rem' }}>
          <a
            className="lf-header-cta lf-btn-primary d-inline-flex"
            style={{ color: '#fff' }}
            onClick={() => {
              handleNavClick('contact');
            }}
          >
            {floral.nav.inquireNow[language]}
          </a>
          <button
            type="button"
            className="lf-btn-secondary d-none d-lg-inline-flex"
            aria-label={languageEN ? 'Switch to Chinese' : 'Switch to English'}
            onClick={handleLanguageToggle}
          >
            <img src="/img/language.png" alt="" style={{ height: '1.3rem', width: 'auto' }} />
          </button>
          <button
            type="button"
            className="lf-hamburger"
            aria-label="Toggle navigation"
            aria-expanded={menuOpen}
            onClick={() => {
              setMenuOpen(!menuOpen);
            }}
          >
            <i className={menuOpen ? 'fa-solid fa-xmark' : 'fa-solid fa-bars'}></i>
          </button>
        </div>
      </div>
      <nav className={`lf-mobile-menu lf-editorial d-lg-none${menuOpen ? ' is-open' : ''}`}>
        <div style={{ borderTop: '1px solid rgba(41,43,39,0.15)', paddingTop: '1rem' }}>
          {NAV_ITEMS.map((item) => {
            return (
              <a
                key={item.id}
                onClick={() => {
                  handleNavClick(item.id);
                }}
              >
                {floral.nav[item.key][language]}
              </a>
            );
          })}
          <a onClick={handleMobileLanguageToggle}>
            {languageEN ? '中文' : 'English'}
          </a>
        </div>
      </nav>
    </header>
  );
}

export { MainHeader };
